import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import TabHome from "@/views/tabs/TabHome.vue";
import TabBetHistory from "@/views/tabs/TabBetHistory.vue";
import TabMy from "@/views/tabs/TabMy.vue";
import TabPay from "@/views/tabs/TabPay.vue";
import HomeTabs from "@/views/HomeTabs.vue";
import AccountDetail from "@/components/pages/BetHisAndDetail/AccountDetail.vue";
import LoginRegister from "@/components/pages/LoginRegister/LoginRegister.vue";
import HWebview from "@/components/utils/HWebview.vue";
import Profile from "@/components/pages/my/Profile.vue";
import Setting from "@/components/pages/my/Setting.vue";
import Device from "@/components/pages/my/Device.vue";
import About from "@/components/pages/my/About.vue";
import Pay from "@/components/pages/Pay.vue";
import Withdraw from "@/components/pages/Withdraw.vue";
import Vip from "@/components/pages/Vip.vue";
import BetHistory from "@/components/pages/BetHisAndDetail/BetHistory.vue";
import WithdrawMgr from "@/components/pages/WithdrawMgr/WithdrawMgr.vue";
import Safe from "@/components/pages/Safe.vue";
import TabReward from "@/views/tabs/TabReward.vue";
import Discount from "@/components/pages/Discount/Discount.vue";
import HEditor from "@/components/utils/HEditor.vue";
import Address from "@/components/pages/my/Address.vue";
import EditAddress from "@/components/pages/my/EditAddress.vue";
import SetTradePwd from "@/components/pages/safe/SetTradePwd.vue";
import BindPhone from "@/components/pages/safe/BindPhone.vue";
import SetLoginPwd from "@/components/pages/safe/SetLoginPwd.vue";
import AddWithdraw from "@/components/pages/WithdrawMgr/AddWithdraw.vue";
import VipDetail from "@/components/pages/VipDetail.vue";
import XimaDetail from "@/components/pages/Discount/XimaDetail.vue";
import Lobby from "@/components/pages/Lobby/Lobby.vue";
import SearchGame from "@/components/pages/SearchGame.vue";

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'main',
            component: HomeTabs,
            children: [
                {
                    path: "home",
                    name: "home",
                    component:TabHome,
                },
                {
                    path: "reward",
                    name: "reward",
                    component:TabReward,
                },
                {
                    path: "recharge",
                    name: "recharge",
                    component:TabPay,
                },
                {
                    path: "bet-his",
                    name: "bet-his",
                    component:TabBetHistory,
                },
                {
                    path: "my",
                    name: "my",
                    component:TabMy,
                },
            ]
        },
        {
            path: '/search',
            name: 'search',
            component: SearchGame,
        },
        {
            path: '/lobby',
            name: 'lobby',
            component: Lobby,
        },
        {
            path: '/rebate-detail',
            name: 'rebate-detail',
            component: XimaDetail,
        },
        {
            path: '/vip-detail',
            name: 'vip-detail',
            component: VipDetail,
        },
        {
            path: '/bind-phone',
            name: 'bind-phone',
            component: BindPhone,
        },
        {
            path: '/add-withdraw',
            name: 'add-withdraw',
            component: AddWithdraw,
        },
        {
            path: '/set-trade-pwd',
            name: 'set-trade-pwd',
            component: SetTradePwd,
        },
        {
            path: '/set-login-pwd',
            name: 'set-login-pwd',
            component: SetLoginPwd,
        },
        {
            path: '/address',
            name: 'address',
            component: Address,
        },
        {
            path: '/edit-address',
            name: 'edit-address',
            component: EditAddress,
        },
        {
            path: '/editor',
            name: 'editor',
            component: HEditor,
        },
        {
            path: '/discount',
            name: 'xima',
            component: Discount,
        },
        {
            path: '/safe',
            name: 'safe',
            component: Safe,
        },
        {
            path: '/pay',
            name: 'pay',
            component: Pay,
        },
        {
            path: '/withdraw',
            name: 'withdraw',
            component: Withdraw,
        },
        {
            path: '/vip',
            name: 'vip',
            component: Vip,
        },
        {
            path: '/account-detail',
            name: 'account-detail',
            component: AccountDetail,
        },
        {
            path: '/bet-history',
            name: 'bet-history',
            component: BetHistory,
        },
        {
            path: '/withdraw-mgr',
            name: 'bind_card',
            component: WithdrawMgr,
        },
        {
            path: '/device',
            name: 'device',
            component: Device,
        },
        {
            path: '/about',
            name: 'about',
            component: About,
        },
        {
            path: '/setting',
            name: 'setting',
            component: Setting,
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
        },
        {
            path: '/login',
            name: 'login',
            component: LoginRegister,
        },
        {
            path: '/wb',
            name: 'wb',
            component: HWebview,
            props(route){
                return route.query;
            }
        },
        {
            path: '',
            redirect: '/home',
        },
    ],
})

export default router
